
import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./HeroSection.css";
import "./layout.css";
import logo from "../assets/herologo.png";
import line from "../assets/line.png";
import arrow from "../assets/arrow.png";
import mailbox from "../assets/mailbox.png";
import callus from "../assets/call.png";
import address from "../assets/address.png";
import SplashPage from "./Splashpage";
import { useNavigate } from 'react-router-dom';


function HeroSection() {

  const navigate = useNavigate();  
  const [isHovered, setIsHovered] = useState(false);
  const [showSplash, setShowSplash] = useState(false);

  const style = {
    background: isHovered ? "black" : "#CCA218",
    margin: 0,
    padding: 0,
    transition: "background-color 0.3s ease",
  };

  const handleButton = () => {
    setShowSplash(true);
    setTimeout(() => {
      setShowSplash(false);
    }, 2000); // Show splash page for 1 second
  };
  const gotoRobotics=()=>{
    navigate('/Robotics-Home');
  }
  
  const gotoHeroca=()=>{
    navigate('/Horeca-Home');
  }

  if (showSplash) {
    return <SplashPage />;
  }

  return (
    <>
    <div className="mycontainer">
      {/* First column */}
      <div className="mycolumn mycolumn-one">
      
        <div className="myrow fullrow">

        <div style={{display:"flex" , alignItems:"center" , justifyContent:"space-between",paddingLeft:"8rem"}} className="pt-4">
         <img src={logo} width="140rem"></img>
         <img src={line}></img>
        </div>
        
        <img src={line} style={{paddingTop:"2rem"}}></img>
          
       <div style={{paddingTop:"7rem"}} className=" px-4">
             <div style={{display:"flex" , alignItems:"center" , justifyContent:"start"}} >
             <img src={mailbox} height="30px" width="30px"></img>
             <p style={{ color: "white" , fontWeight:"500",marginBottom:"0px",marginLeft:"8px",fontSize:"0.8rem" }}>Email</p>
             </div>
            <p style={{ color: "#D4D4D4",marginBottom:"0px",fontSize:"0.8rem"}} className="pt-2"> info@co6.ae</p>
            

      </div>
      <img src={line} style={{paddingTop:"1.5rem"}}></img>
      <div className="pt-3 px-4">
             <div style={{display:"flex" , alignItems:"center" , justifyContent:"start"}} >
             <img src={callus} width="20px" ></img>
             <p style={{ color: "white" , fontWeight:"500",marginBottom:"0px",marginLeft:"8px",fontSize:"0.8rem" }}>Call Us </p>
             </div>
            <p style={{ color: "#D4D4D4",marginBottom:"0px",fontSize:"0.8rem"}} className="pt-2"> +971 2 6811812</p>
            

      </div>
      <img src={line} style={{paddingTop:"1.5rem"}}></img>
      <div className="pt-2 px-4">
             <div style={{display:"flex" , alignItems:"center" , justifyContent:"start"}} >
             <img src={address} height="30px" width="30px"></img>
             <p style={{ color: "white" , fontWeight:"500",marginBottom:"0px",marginLeft:"8px",fontSize:"0.8rem" }}>Address </p>
             </div>
            <p style={{ color: "#D4D4D4",marginBottom:"0px",fontSize:"0.8rem" }} className="pt-2">Office 1602 & 1603, Abdullah Bin Darwish Building, Salam <br></br> & Hamdan St Junction, Abu Dhabi<br></br>United Arab Emirates  </p>
            

      </div>
      <img src={line} style={{paddingTop:"1.5rem"}}></img>

      </div>
      
      </div>
     
      {/* Second column */}
      <div className="mycolumn mycolumn-two">
        <div className="myrow myrow-top image-background2 px-5" style={{paddingTop:"4.5rem", paddingBottom:"4.5rem"}}>
        <div className="soildhover" style={{backgroundColor:"rgba(204, 162, 24, 0.65)" , height:"100%", display:"flex", flexDirection:"column" ,alignItems:"center" ,justifyContent:"space-between",paddingTop:"2rem", paddingBottom:"2rem"}}> 

        <h1 className="pt-4 px-4"  style={{fontWeight:"500", textAlign:"center" , fontSize:"2rem"}}>
        Robotic <br></br>Automation
        
        </h1>
        
        <div style={{display:"flex" , alignItems:"center" , justifyContent:"space-between",width:"80%"}} className="pt-3 px-2">
        <p
                style={{
                  color: "white",
                  textTransform: "uppercase",
                  letterSpacing: "5px",
                  fontWeight:"500",
                  fontSize:"0.8rem",
                  marginBottom:"0px"
                }}
              >
                Learn More
              </p>
              <button className="button-robot" onClick={gotoRobotics}>
                <img src={arrow} alt="Arrow Icon" />
              </button>
            </div>
        </div>
          

        </div>
        
      </div>

      {/* Third column */}
      <div className="mycolumn mycolumn-three">
      
        <div className="myrow myrow-bottom image-background1  px-5" style={{paddingTop:"4.5rem", paddingBottom:"4.5rem"}}>

          <div className="solidhover" style={{backgroundColor:"rgba(2, 1, 9, 0.8)" , height:"100%", display:"flex", flexDirection:"column" ,alignItems:"center" ,justifyContent:"space-between",paddingTop:"2rem", paddingBottom:"2rem"}}> 

        <h1 className="pt-4 px-4"  style={{fontWeight:"500",fontSize:"2.5rem"}}>
        HORECA
        
        </h1>
        
        <div style={{display:"flex" , alignItems:"center" , justifyContent:"space-between",width:"80%"}} className="pt-3 px-2">
        <p
                style={{
                  color: "white",
                  textTransform: "uppercase",
                  letterSpacing: "5px",
                  fontWeight:"500",
                  fontSize:"0.8rem",
                  marginBottom:"0px"
                }}
              >
                Learn More
              </p>
              <button className="button-food" onClick={gotoHeroca}>
                <img src={arrow} alt="Arrow Icon" />
              </button>
        </div>
        </div>

        </div>
      </div>
      <div>

      </div>
     
    </div>

    {/* <div className="container" style={{height:"40vh"}}><AnimationBox><div>HELLO</div></AnimationBox></div> */}
        <div className="mobilecontainer">
        <div style={{display:"flex" , alignItems:"center" , justifyContent:"center",overflow:"hidden" ,backgroundColor:"black"}} className="py-4 ">
        <img src={line}></img>
           <img src={logo}></img>
           <img src={line}></img>
          </div>
  
        {/* Second column */}
        <div className="mycolumn mycolumn-two">
        <div className="myrow myrow-top image-background2 px-4" style={{paddingTop:"4rem", paddingBottom:"4rem"}}>
        <div className="soildhover" style={{backgroundColor:"rgba(204, 162, 24, 0.65)" ,height:"50vh", display:"flex", flexDirection:"column" ,alignItems:"center" ,justifyContent:"space-between",paddingTop:"2rem", paddingBottom:"2rem"}}> 

        <h1 className="pt-4 px-4"  style={{fontWeight:"500", textAlign:"center" , fontSize:"2.5rem"}}>
        Robotic <br></br>Automation
        
        </h1>
        
        <div style={{display:"flex" , alignItems:"center" , justifyContent:"space-between",width:"80%"}} className="pt-3 px-2">
        <p
                style={{
                  color: "white",
                  textTransform: "uppercase",
                  letterSpacing: "5px",
                  fontWeight:"500",
                  fontSize:"0.8rem",
                  
                }}
              >
                Learn More
              </p>
              <button className="button-robot" onClick={gotoRobotics}>
                <img src={arrow} alt="Arrow Icon" />
              </button>
            </div>
        </div>
          

        </div>
        
      </div>
        {/* Third column */}
        <div className="mycolumn mycolumn-three">
        
        <div className="myrow myrow-bottom image-background1  px-4" style={{paddingTop:"4rem", paddingBottom:"4rem"}}>

          <div className="solidhover" style={{backgroundColor:"rgba(2, 1, 9, 0.8)" , height:"50vh", display:"flex", flexDirection:"column" ,alignItems:"center" ,justifyContent:"space-between",paddingTop:"2rem", paddingBottom:"2rem"}}> 

        <h1 className="pt-4 px-4"  style={{fontWeight:"500",fontSize:"2.5rem"}}>
        HORECA
        
        </h1>
        
        <div style={{display:"flex" , alignItems:"center" , justifyContent:"space-between",width:"80%"}} className="pt-3 px-2">
        <p
                style={{
                  color: "white",
                  textTransform: "uppercase",
                  letterSpacing: "5px",
                  fontWeight:"500",
                  fontSize:"0.8rem",
                  marginBottom:"0px"
                }}
              >
                Learn More
              </p>
              <button className="button-food" onClick={gotoHeroca}>
                <img src={arrow} alt="Arrow Icon" />
              </button>
        </div>
        </div>

        </div>
      </div>
        {/* First column */}
        <div className="mycolumn mycolumn-one" style={{backgroundSize:"100% 100%"}}>
  
          
          
          
         <div className="pt-3 px-5">
               <div style={{display:"flex" , alignItems:"center" , justifyContent:"start"}} >
               <img src={mailbox} height="30px" width="30px"></img>
               <p style={{ color: "white" , fontWeight:"500",marginBottom:"0px",marginLeft:"8px" }}>Email Address </p>
               </div>
              <p style={{ color: "#D4D4D4",marginBottom:"0px"}} className="pt-2"> info@co6.ae</p>
              
  
        </div>
        <img src={line} style={{paddingTop:"1.5rem"}}></img>
        <div className="pt-3 px-5">
               <div style={{display:"flex" , alignItems:"center" , justifyContent:"start"}} >
               <img src={callus} width="20px" ></img>
               <p style={{ color: "white" , fontWeight:"500",marginBottom:"0px",marginLeft:"8px" }}>Call Us </p>
               </div>
              <p style={{ color: "#D4D4D4",marginBottom:"0px"}} className="pt-2"> +971 2 6811812</p>
              
  
        </div>
        <img src={line} style={{paddingTop:"1.5rem"}}></img>
        <div className="pt-2 px-5">
               <div style={{display:"flex" , alignItems:"center" , justifyContent:"start"}} >
               <img src={address} height="30px" width="30px"></img>
               <p style={{ color: "white" , fontWeight:"500",marginBottom:"0px",marginLeft:"8px" }}>Address </p>
               </div>
              <p style={{ color: "#D4D4D4",marginBottom:"0px" }} className="pt-2">Office 1602 & 1603, Abdullah Bin Darwish Building, Salam  & Hamdan St Junction , Abu Dhabi United Arab Emirates</p>
              
  
        </div>
        <img src={line} style={{paddingTop:"1.5rem"}}></img>
  
  
        </div>
      </div>
      </>
  );
}

export default HeroSection;